import axios from 'axios';

export const isLocal = false;

export const api = axios.create({
  baseURL: isLocal ? 'http://localhost:5000/api' : 'https://quaythuongbaocuong.com/apihonda', // URL backend
});
